import React from "react";

const CustomPolarAngleAxisTick: React.FC<any> = (props) => {
    const { x, y, cx, cy, payload } = props;

    const dx = x - cx;
    const dy = y - cy;
    const distance = 7;

    const adjustedX = x + (dx * distance) / Math.sqrt(dx * dx + dy * dy) - 8;
    const adjustedY = y + (dy * distance) / Math.sqrt(dx * dx + dy * dy) - 10;

    const extractNumberFromHTML = (htmlString : string) => {
        const number = htmlString.match(/\d+/);

        return number ? parseInt(number[0], 10) : null;
    };
    return (
        <foreignObject
            x={adjustedX}
            y={adjustedY}
            textAnchor="middle"
            fill="#333"
            fontWeight={'bold'}
            fontSize={16}
            className={"circle-number"}
        >
            <span className={"circle-number"}>{extractNumberFromHTML(payload.value)}</span>
        </foreignObject>

    );
};

export default CustomPolarAngleAxisTick;
